import React from "react";
import { Stack } from "@chakra-ui/core";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { i18n } from "next-i18next";

import Navbar from "~/sections/Navbar";
import AboutHero from "~/sections/AboutHero";
import Footer from "~/sections/Footer";
import TechForPeople from "~/sections/TechForPeople";
import OurCulture from "~/sections/OurCulture";
//import Team from "~/sections/Team";
import { useTranslation } from "~/i18n/hooks";

const AboutRoute: React.FC = () => {
  const t = useTranslation();

  return (
    <Stack height="100%" minHeight="100vh" spacing={0}>
      <Head>
        <title>{t("aboutUs.title")}</title>
        <meta content={t("aboutUs.description")} name="description" />
        <meta content={t("home.keywords")} name="keywords" />
        <link
          href={`${process.env.URL}/nosotros`}
          hrefLang="x-default"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/nosotros`}
          hrefLang="es"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/pt/sobre-nos`}
          hrefLang="pt"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/en/about`}
          hrefLang="en"
          rel="alternate"
        />
        <meta content={t("home.title")} property="og:title" />
        <meta content={t("home.description")} property="og:description" />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="og:image:url"
        />
        <meta content={t("home.title")} name="twitter:title" />
        <meta content={t("home.description")} name="twitter:description" />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="twitter:image"
        />
        <meta
          name="facebook-domain-verification"
          content="zkpe1pbv54w2vb37xfieodiezyc606"
        />
      </Head>
      <Navbar backgroundColor="primary.100" color="primary.900" />
      <AboutHero />
      <TechForPeople />
      <OurCulture />
      {/* <Team /> */}
      <Footer />
    </Stack>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  // Return stores so we can build a directory
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
};

export default AboutRoute;
